var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinButtonLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15802",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15802",
    transform: "translate(23448 -14080)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15799",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15799",
    transform: "translate(-23447.789 14116.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21769",
    "data-name": "\\u30D1\\u30B9 21769",
    d: "M500.46-359.56a16.589,16.589,0,0,0-16.541-16.6,16.589,16.589,0,0,0-16.541,16.6,16.622,16.622,0,0,0,11.491,15.808,9.91,9.91,0,0,0-4.286,5.67,1.267,1.267,0,0,0-.031.458h2.563a8.006,8.006,0,0,1,1.333-2.407,6.993,6.993,0,0,1,5.725-2.594,7.194,7.194,0,0,1,7.06,5H493.8a1.282,1.282,0,0,0-.031-.458,9.9,9.9,0,0,0-4.468-5.779A16.624,16.624,0,0,0,500.46-359.56ZM483.919-345.7a13.845,13.845,0,0,1-13.8-13.859,13.845,13.845,0,0,1,13.8-13.859,13.846,13.846,0,0,1,13.8,13.859A13.846,13.846,0,0,1,483.919-345.7Z",
    transform: "translate(-467.379 376.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21770",
    "data-name": "\\u30D1\\u30B9 21770",
    d: "M535.83-306.695l-8.8-7.479a1.827,1.827,0,0,0-2.575.209,1.827,1.827,0,0,0,.209,2.575l8.8,7.479a1.82,1.82,0,0,0,1.182.435,1.823,1.823,0,0,0,1.393-.644A1.826,1.826,0,0,0,535.83-306.695Z",
    transform: "translate(-513.674 325.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15800",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15800",
    transform: "translate(-23372.303 14116.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21769-2",
    "data-name": "\\u30D1\\u30B9 21769",
    d: "M500.46-359.56a16.589,16.589,0,0,0-16.541-16.6,16.589,16.589,0,0,0-16.541,16.6,16.622,16.622,0,0,0,11.491,15.808,9.91,9.91,0,0,0-4.286,5.67,1.267,1.267,0,0,0-.031.458h2.563a8.006,8.006,0,0,1,1.333-2.407,6.993,6.993,0,0,1,5.725-2.594,7.194,7.194,0,0,1,7.06,5H493.8a1.282,1.282,0,0,0-.031-.458,9.9,9.9,0,0,0-4.468-5.779A16.624,16.624,0,0,0,500.46-359.56ZM483.919-345.7a13.845,13.845,0,0,1-13.8-13.859,13.845,13.845,0,0,1,13.8-13.859,13.846,13.846,0,0,1,13.8,13.859A13.846,13.846,0,0,1,483.919-345.7Z",
    transform: "translate(-467.379 376.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21770-2",
    "data-name": "\\u30D1\\u30B9 21770",
    d: "M535.83-306.695l-8.8-7.479a1.827,1.827,0,0,0-2.575.209,1.827,1.827,0,0,0,.209,2.575l8.8,7.479a1.82,1.82,0,0,0,1.182.435,1.823,1.823,0,0,0,1.393-.644A1.826,1.826,0,0,0,535.83-306.695Z",
    transform: "translate(-513.674 325.853)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15801",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15801",
    transform: "translate(-23418.168 14106.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21769-3",
    "data-name": "\\u30D1\\u30B9 21769",
    d: "M515.357-352.085a24.059,24.059,0,0,0-23.99-24.074,24.059,24.059,0,0,0-23.989,24.074,24.107,24.107,0,0,0,16.666,22.926,14.371,14.371,0,0,0-6.216,8.223,1.837,1.837,0,0,0-.044.664H481.5a11.618,11.618,0,0,1,1.933-3.491,10.142,10.142,0,0,1,8.3-3.762,10.433,10.433,0,0,1,10.239,7.252h3.715a1.849,1.849,0,0,0-.045-.665,14.362,14.362,0,0,0-6.48-8.381A24.11,24.11,0,0,0,515.357-352.085Zm-23.99,20.1a20.08,20.08,0,0,1-20.015-20.1,20.08,20.08,0,0,1,20.015-20.1,20.08,20.08,0,0,1,20.015,20.1A20.08,20.08,0,0,1,491.367-331.985Z",
    transform: "translate(-467.379 376.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_21770-3",
    "data-name": "\\u30D1\\u30B9 21770",
    d: "M541.147-303.132l-12.759-10.846a2.649,2.649,0,0,0-3.735.3,2.65,2.65,0,0,0,.3,3.735l12.759,10.846a2.64,2.64,0,0,0,1.715.631,2.643,2.643,0,0,0,2.02-.934A2.649,2.649,0,0,0,541.147-303.132Z",
    transform: "translate(-509.015 330.917)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10628",
    "data-name": "\\u9577\\u65B9\\u5F62 10628",
    width: 109,
    height: 109,
    transform: "translate(-23448 14080)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinButtonLeft);
export default __webpack_public_path__ + "static/media/joinButtonLeft.90a8c34570a6af08297b6331629217a2.svg";
export { ForwardRef as ReactComponent };